import { defineStore } from "pinia";
import { ref } from "vue";
import { usePhysicalPersonStore } from "@/stores/physicalPerson";
import { useCompanyStore } from "@/stores/company";
import { useBase, useServerPaginatedCollection } from "@/utils/stores/base";

export const useCustomerStore = defineStore("customers", () => {
  const searchQuery = ref(null);
  const { baseFetchPage } = useBase();
  const companyStore = useCompanyStore();
  const physicalPersonStore = usePhysicalPersonStore();
  const customers = ref([]);

  const {
    fetchAll,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    goToPage,
    goToNextPage,
    goToPreviousPage,
    currentPage,
    totalCount,
    totalPages,
    paginationRange
  } = useServerPaginatedCollection({
    resources: customers,
    itemsPerPage: 10,
    searchQuery,
    fetchPage: async (errorCallback, includes, page, perPage, extraParams) => {
      return await baseFetchPage("customers", errorCallback, includes, { page, perPage, extraParams });
    }
  });

  const watchSourceChanges = async (callback) => {
    await companyStore.watchResourceChanges(callback);
    await physicalPersonStore.watchResourceChanges(callback);
  };

  return {
    customers: customers,
    paginatedCustomers: customers,
    goToPage,
    goToNextPage,
    goToPreviousPage,
    paginationRange,
    totalPages,
    searchQuery,
    currentPage,
    totalCount,
    fetchAll,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    watchSourceChanges
  };
});
